import { combineReducers } from "redux";

import { bookingsAdminSliceReducer, initialState as bookingsInitialState } from "../Bookings/Redux/BookingsAdminSlice"
import { adminGlobalReducer, initialState as adminGlobalInitialState } from "./AdminGlobalSlice";


export const adminRootReducer = combineReducers({
    global: adminGlobalReducer,
    module: combineReducers({
        ['BOOKINGS']: bookingsAdminSliceReducer,
    })
});

export const initialState = {
    global: adminGlobalInitialState,
    module: {
        ['BOOKINGS']: bookingsInitialState
    },
}
